<template>
	<v-container>

		<v-page-header :color="$root.colorHeader" :titulo="$root.titleHeader" />

		<v-card tile>

			<!-- <v-row class="ml-4 mr-4">
			</v-row> -->
			
			<v-row class="ml-4 mr-4">
				<v-col md="11">
					<v-text-field
						outlined
						v-model="searchText"
						label="Pesquisa"
						clearable
						autofocus
					/>
				</v-col>
			</v-row>

			<v-dotacao-list v-model="dotacoes" :searchText="searchText" />
		
		</v-card>
		
	</v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import VPageHeader from '@/components/PageHeader.vue';
import VDotacaoList from '@/components/DotacaoList.vue';

export default {
	name: 'Home',
	data() {
		return {
			searchText: null,

			dotacoes: [],

			emendas: [],
			emendasSelecionadas: [],
			loading: false,
			// headers: [
			// 	{ text: 'No.', value: 'numeroEmenda' },
			// 	{ text: 'Ano', value: 'anoExercicio' },
			// 	{ text: 'Descrição', value: 'descricao' },
			// 	{ text: 'Secretaria destino', value: 'secretaria.sigla' },
			// 	{ text: 'Parlamentar', value: 'nomeParlamentar' },
			// 	{ text: 'Situação', value: 'situacao.descricao' },
			// 	{ text: 'Esfera', value: 'esfera' },
			// 	{ text: 'Valor da Emenda (R$)', value: 'valor$' },
			// 	{ text: 'Valor Fixado Final (R$)', value: 'valorFixadoFinal$' }
			// ],
			noDataMessage:
				'Não foram encontrados registros para esfera e ano de exercício selecionados.',
			itemsPerPage: 10,
			page: 1,

			esfera: null,
			anoOrcamento: null,
			secretarias: null,
			situacoes: null,

			esferaItems: [],
			anoOrcamentoItems: [],
			secretariaItems: [],
			situacaoItems: [],

			exibirTramitacao: false,
			despachoValido: null,
			despacho: null,
			novaSituacao: null,
			situacaoFluxoDestinoItems: null,
			despachoSituacao: null
		};
	},
	components: {VPageHeader, VDotacaoList},
	async created() {
		this.fetchEsferaItems();
		//this.fetchSituacoesItems();     //??
		this.fetchSecretarias();
		this.fetchSituacoes();

		this.$root.colorHeader = "green";
		this.$root.titleHeader = "Consulta de Dotações";

	},
	// computed: {
	// 	emendasSelecionadasSituacao() {
	// 		if (this.despachoSituacao && this.despachoSituacao.id) {
	// 			return this.emendasSelecionadas.filter(
	// 				e => e.situacao.id == this.despachoSituacao.id
	// 			);
	// 		}

	// 		return [];
	// 	}
	// },
	watch: {
		esfera(val) {
			let id = val && val.id;
			this.fetchAnos(id);
		},
		anoOrcamento() {
			this.fetchDotacoes();
		},
		secretarias() {
			this.fetchDotacoes();
		},
		situacoes() {
			this.fetchDotacoes();
		},
		searchText() {
			this.page = 1;
		}
	},
	methods: {
		// novo() {
		// 	this.$router.push('/emendas/novo');
		// },
		// rowClick(item) {
		// 	this.$router.push(`/emendas/${item.id}`);
		// },
		async fetchDotacoes() {
			try {
				let dotacoes = await this.$fetch.get('emendas/listarDotacoes', {
					//anoExercicio: this.anoExercicio.anoExercicio,
					anoExercicio: this.$root.anoSelecionado
					//idEsfera: this.esfera.id,
					//idSecretaria: this.secretarias.id,
					//idSituacao: this.situacoes.id
				});
				// emendas.forEach(emenda => {
				// 	emenda.valor$ = this.setMascara(emenda.valor);
				// 	emenda.valorFixadoFinal$ = this.setMascara(emenda.valorFixadoFinal);
				// 	if (
				// 		this.$root.usuarioLogado &&
				// 		this.$root.usuarioLogado.funcoes &&
				// 		this.$root.usuarioLogado.funcoes.includes('EMENDA_ALTERAR')
				// 	) {
				// 		emenda.isSelectable = true;
				// 	} else if (emenda.situacao.id === 3) {
				// 		emenda.isSelectable = true;
				// 	} else {
				// 		emenda.isSelectable = false;
				// 	}
				// });
				this.dotacoes = dotacoes;
			} catch (err) {
				this.noDataMessage = err.msg;
			}
		},
		async fetchEsferaItems() {
			try {
				this.esferaItems = await this.$fetch.get('parlamentares/esferas');
				this.esferaItems.splice(0, 0, { id: null, descricao: 'Todos' });
				this.esfera = this.esferaItems[0];
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar esferas',
					msg: err.msg
				};
			}
		},

		// async fetchSituacoesItems() {
		// 	try {
		// 		this.situacaoItems = await this.$fetch.get('emendas/situacoes');
		// 	} catch (err) {
		// 		this.$root.dialog = {
		// 			title: 'Não foi possível carregar situações',
		// 			msg: err.msg
		// 		};
		// 	}
		// },

		async fetchSituacoesDestinoItems(idFluxoOrigem) {
			try {
				this.situacaoFluxoDestinoItems = await this.$fetch.get('emendas/situacoesFluxoDestino', {
					idFluxoOrigem
			});
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar situações',
					msg: err.msg
				};
			}
		},

		async fetchAnos(idEsfera) {
			this.anoOrcamentoItems = await this.$fetch.get('emendas/anos', {
				idEsfera
			});
			console.log('t ',this.anoOrcamentoItems);
			this.anoOrcamentoItems.splice(0, 0, { anoOrcamento: 'Todos' });
			this.anoOrcamento = this.anoOrcamentoItems[0];
			this.fetchDotacoes();
		},

		async fetchSecretarias() {
			this.secretariaItems = await this.$fetch.get('emendas/secretarias');
			if (this.$root.usuarioLogado &&
					this.$root.usuarioLogado.perfis &&
					this.$root.usuarioLogado.perfis.includes('Administrador')) {
				this.secretariaItems.splice(0, 0, { id: null, nome: 'Todas' });
			}
			this.secretarias = this.secretariaItems[0];
			this.fetchDotacoes();
		},

		async fetchSituacoes() {
			this.situacaoItems = await this.$fetch.get('emendas/situacoes');
			this.situacaoItems.splice(0, 0, { id: null, descricao: 'Todas' });
			if (this.$root.usuarioLogado &&
					this.$root.usuarioLogado.perfis &&
					this.$root.usuarioLogado.perfis.includes('Administrador')) {
				this.situacoes = this.situacaoItems[0];
			}
			else
				this.situacoes = this.situacaoItems.find( a => a.id === 3 );
			this.fetchDotacoes();
		},

		setMascara(v) {
			if (v >= 0) {
				return v.toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
					style: 'currency',
					currency: 'BRL'
				});
			}
			return '-';
		},

		customSort(items, index, isDesc) {
			items.sort((a, b) => {
				if (index[0] && index[0].slice(-1) === '$') {
					if (!isDesc[0]) {
						return a[index[0].slice(0, -1)] < b[index[0].slice(0, -1)] ? -1 : 1;
					} else {
						return b[index[0].slice(0, -1)] < a[index[0].slice(0, -1)] ? -1 : 1;
					}
				} else if (a[index]) {
					if (!isDesc[0]) {
						return a[index] < b[index] ? -1 : 1;
					} else {
						return b[index] < a[index] ? -1 : 1;
					}
				}
				else {
					// campos "filhos" tem que fazer a ordenação na mão
					if ((index[0] == 'situacao.descricao') || (index[0] == 'secretaria.sigla'))
					{
						var campoA, campoB, ordem;

						if (index[0] == 'situacao.descricao')
						{
							campoA = a['situacao'];
							campoB = b['situacao'];

							ordem = 'descricao';
						}

						if (index[0] == 'secretaria.sigla')
						{
							campoA = a['secretaria'];
							campoB = b['secretaria'];

							ordem = 'sigla'
						}

						if (!isDesc[0]) {
							return campoA[ordem].toLowerCase().localeCompare(campoB[ordem].toLowerCase());
						} else
						{
							return campoB[ordem].toLowerCase().localeCompare(campoA[ordem].toLowerCase());
						}
					}
				}
			});

			return items;
		},

		// async clickTramitar(emendasSelecionadas) {

		// 	let situacaoEmendas = [];

		// 	// montar uma array só com o campo situação
		// 	emendasSelecionadas.forEach((sit) => { situacaoEmendas.push(sit.situacao.id) });

		// 	// verificando se foram selecionadas emendas com situações diferentes
		// 	var idSituacao = situacaoEmendas.filter(function(elem, pos, arr) {
		// 		return arr.indexOf(elem) == pos;
		// 	});

		// 	let mesmaSituacao = (idSituacao.length === 1); 
			
		// 	if (mesmaSituacao)
		// 	{
		// 		if ( (emendasSelecionadas.length == 1) || ( (this.$root.usuarioLogado &&
		// 				this.$root.usuarioLogado.funcoes &&
		// 				this.$root.usuarioLogado.funcoes.includes('EMENDA_ALTERAR')) ) ) {
		// 			this.fetchSituacoesDestinoItems(idSituacao);
		// 			this.exibirTramitacao = true;
		// 		} else {
		// 			this.$root.dialog = { title: 'Tramitação não permitida', msg: 'Selecione somente uma emenda para tramitação por vez.' };
		// 		}
		// 	}
		// 	else {
		// 		this.$root.dialog = { title: 'Tramitação não permitida', msg: 'Selecione somente emendas na mesma situação.' };
		// 	}

		// },

		// async tramitar() {
		// 	await this.$refs.formDespacho.validate();

		// 	if (this.despachoValido) {
		// 		let emendasTramitar = this.emendasSelecionadas
		// 			.filter(e => e.situacao.id !== this.despachoSituacao.id)
		// 			.map(e => e.id);
		// 		let tramitacao = {
		// 			despacho: this.despacho,
		// 			emendasTramitar,
		// 			situacao: this.despachoSituacao
		// 		};

		// 		this.exibirTramitacao = false;

		// 		try {
		// 			let qtdEmendasSalvas = await this.$fetch.post(
		// 				`emendas/tramitar`,
		// 				tramitacao
		// 			);

		// 			this.$emit('snack', {
		// 				show: true,
		// 				text: `${qtdEmendasSalvas} emendas tramitadas com sucesso para ${this.despachoSituacao.descricao}`
		// 			});

		// 			await this.resetTramitacao();

		// 			this.fetchDotacoes();
		// 		} catch (err) {
		// 			this.$root.dialog = { title: 'Emenda não salva', msg: err.msg };
		// 		}
		// 	}
		// },

		// async cancelarTramitacao() {
		// 	await this.resetTramitacao();

		// 	this.exibirTramitacao = false;
		// },

		// async resetTramitacao() {
		// 	this.despacho = null;
		// 	this.despachoSituacao = null;
		// 	await this.$refs.formDespacho.reset();
		// },

		temFuncao(fn) {
			return (
				this.$root.usuarioLogado &&
				this.$root.usuarioLogado.funcoes &&
				this.$root.usuarioLogado.funcoes.includes(fn)
			);
		}
	}
};
</script>

<style scoped>
.head-tile {
	margin: -10px -10px 0 -10px;
}

.row-pointer >>> tbody tr :hover {
	cursor: pointer;
}
.situacao {
	font-weight: bold;
	color: orangered;
}
.emendas {
	font-weight: bold;
	color: purple;
}
.info-despacho {
	text-align: center;
	font-size: 80%;
}
</style>
